export const SPACE_SIZES = [
  { label: "Small - up to 4 x 4 (m)", value: "small" },
  { label: "Medium - 4 x 4 to 8 x 8 (m)", value: "medium" },
  { label: "Large - 8 x 8 (m) and above", value: "large" },
  { label: "Custom", value: "custom", isClosable: false },
];

export const DEFAULT_SIZES = { width: null, length: null };
